import React, { useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import warn from '../Assets/warn.png';
import { useTranslation } from "react-i18next";

export default function LocationHelperModal({ open, onClose, onRefresh }) {
  const { t } = useTranslation();

  const isMobile = useMemo(() => {
    if (typeof navigator === "undefined") return false;
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  }, []);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: { borderRadius: 3, p: 1 },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{ position: "absolute", right: 12, top: 12, color: "grey.500" }}
      >
        <CloseIcon />
      </IconButton>

      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: 600,
          fontSize: "1.25rem",
        }}
      >
        <img src={warn} alt="" width={70} style={{ marginBottom: 2 }} />
        <br />
        {t("locationmodeltext")}
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ textAlign: "center" }}>
        {!isMobile ? (
          <>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <b>{t("Chrome/Edge:")}</b>{" "}
              {t("Click the padlock icon in the address bar → Site settings → Location → Allow, then reload.")}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <b>{t("Firefox:")}</b>{" "}
              {t("Click the shield/info icon → Permissions → Location → Allow, then reload.")}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <b>{t("Safari (macOS):")}</b>{" "}
              {t("Safari Settings → Websites → Location → Allow, then reload.")}
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <b>{t("iOS Safari/Chrome:")}</b>{" "}
              {t("Settings → Safari/Chrome → Location → While Using the App; or Settings → Privacy & Security → Location Services.")}
            </Typography>
            <Typography variant="body1">
              <b>{t("Android Chrome:")}</b>{" "}
              {t("Tap padlock → Permissions → Location → Allow → Refresh.")}
            </Typography>
          </>
        )}
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          pb: 2,
        }}
      >
        <Button
          variant="contained"
          onClick={onRefresh}
          sx={{ px: { xs: 2, md: 4 }, borderRadius: 2 }}
        >
          {t("I’ve enabled it")}
        </Button>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{ px: { xs: 2, md: 4 }, borderRadius: 2 }}
        >
          {t("Cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}